import PropTypes from 'prop-types';

const SearchBar = ({ value, onChange }) => {
  const handleChange = e => onChange(e.target.value);

  return (
    <div className="searchBar">
      <input placeholder="Find an app" value={value} onChange={handleChange} />
    </div>
  );
};

SearchBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default SearchBar;
